import type { CreationInfo, CreationWithTask } from '@/app/types';
import { BackfillTaskType } from '@/app/types';
import { isExtendTask, isVideoDurationWithinRange } from '@/app/utils';

export const VIDEO_APPLY_TARGETS: Array<{
  labelKey: string;
  key: BackfillTaskType;
  path: string;
  minDuration: number;
  maxDuration: number;
}> = [
  {
    labelKey: 'create.tabLipSync',
    key: BackfillTaskType.LIP_SYNC,
    path: '/create/lip-sync',
    minDuration: 1,
    maxDuration: 120,
  },
  {
    labelKey: 'create.tabFaceSwap',
    key: BackfillTaskType.FACE_SWAP,
    path: '/create/face-swap',
    minDuration: 1,
    maxDuration: 8,
  },
  {
    labelKey: 'create.tabMotionControl',
    key: BackfillTaskType.MOTION_CONTROL,
    path: '/create/motion-control',
    minDuration: 2,
    maxDuration: 30,
  },
];

export const getVideoApplyDuration = (creation: CreationInfo | CreationWithTask): number => {
  if ('task' in creation && isExtendTask(creation.task.type)) {
    return creation.duration || 0;
  }

  if ('task' in creation && typeof creation.task.settings?.duration === 'number') {
    return creation.task.settings.duration;
  }

  return creation.duration || 0;
};

export const getAvailableVideoApplyTargets = (duration: number) => {
  return VIDEO_APPLY_TARGETS.filter((target) =>
    isVideoDurationWithinRange({
      duration,
      minDuration: target.minDuration,
      maxDuration: target.maxDuration,
    }),
  );
};
